<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
					<!-- 전표구분 -->
					<select-combo :label="getMessage_('QWCC001296')" paramKey="slipScn" :options="slipScnList" @commChange="changeParam" />
				</el-col>
				<el-col :span="3">
					<!-- 검색날짜 -->
					<select-combo
						:label="getMessage_('QWCC001393')"
						:showAll="false"
						paramKey="clmDd02"
						:options="clmDd02List"
						:propData="searchParams.clmDd02"
						@commChange="changeParam"
					/>
				</el-col>
				<el-col :span="5">
					<!-- 변제확정월 -->
					<sf-group-wrapper :label="getMessage_('QWCC001394')">
						<el-date-picker
							v-model="searchDcsnDdDt"
							@change="changeSearchDate"
							type="monthrange"
							align="right"
							start-placeholder="Start Date"
							end-placeholder="End Date"
							range-separator="~"
							format="yyyy-MM"
							value-format="yyyy-MM"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>
				<!-- </el-row>
			<el-row :gutter="20"> -->
				<el-col :span="3">
					<!--업체 (업체명칭)-->
					<search-input
						:label="getMessage_('QWCC001924')"
						paramKey="dlrCpnyNm"
						@commInput="changeParam"
						:propData="searchParams.dlrCpnyNm"
					/>
				</el-col>
				<el-col :span="3">
					<!--품번-->
					<search-input
						:label="getMessage_('QWCC000956')"
						paramKey="causPartNo"
						@commInput="changeParam"
						:propData="searchParams.causPartNo"
					/>
				</el-col>
				<!--캠페인 No-->
				<!-- <el-col :span="3">
					<search-input :label="getMessage_('QWCC001024')" paramKey="cmpnNo" @commInput="changeParam" :propData="searchParams.cmpnNo" />
				</el-col> -->

				<!--ctype-->
				<el-col :span="4">
					<select-combo
						:label="getMessage_('QWCC001056')"
						paramKey="ctype"
						:options="ctypeList"
						:propData="searchParams.ctype"
						@commChange="changeParam"
					></select-combo>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/RepayMst/store/helpers';
import SelectCombo from '@qms/Components/SelectCombo.vue';
import SearchInput from '@qms/Components/SearchInput';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' },
		showAll: {}
	},
	data() {
		let startDt = this.$moment().startOf('month').format('YYYY-MM-DD');
		let endDt = this.$moment().endOf('month').format('YYYY-MM-DD');
		return {
			searchDcsnDdDt: [new Date(startDt), new Date(endDt)]
		};
	},
	components: { SearchInput, SelectCombo },
	computed: {
		...rootComputed,
		...serviceComputed,
		insVali() {
			return yup.object().shape({
				startDcsnDd: yup //확정월
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001297')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001297')])),
				endDcsnDd: yup //확정월
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001297')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001297')]))
			});
		}
	},
	methods: {
		...serviceMethods,
		async changeParam(param) {
			await this.setSearchParam_(param);
		},
		searchList() {
			if (this.searchDcsnDdDt) {
				this.setSearchParam_({ key: 'startDcsnDd', value: this.$moment(this.searchDcsnDdDt[0]).format('YYYYMMDD') });
				this.setSearchParam_({ key: 'endDcsnDd', value: this.$moment(this.searchDcsnDdDt[1]).format('YYYYMMDD') });
				const searchParams = this.searchParams;
				//벨리데이션 체크
				try {
					this.insVali.validateSync(searchParams);
				} catch (error) {
					// const today = this.$moment().format('YYYY-MM'); //오늘날짜
					// this.changeSearchDate(today);
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					return error;
				}
				this.$sf_toggleLoading(true);
				this.getRepayMst_()
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});

				this.setStateClear_();
			} else {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000008'),
					message: this.getMessage_('QWCC001682')
				}); //필수 검색 값을 확인해주십시오
			}
		},
		changeSearchDate(data) {
			let from;
			let to;

			if (data) {
				from = this.$moment(data[0]).format('YYYY-MM-DD');
				to = this.$moment(data[1]).format('YYYY-MM-DD');
			} else {
				from = '';
				to = '';
			}

			this.selectDate = { from, to };
		}
	},

	async created() {
		try {
			this.$sf_toggleLoading(true);
			await this.getCommCodes_({ key: 'slipScnList', codeType: 'SLIP_SCN' }); //전표구분
			await this.getCommCodes_({ key: 'ctypeList', codeType: 'CLM_TYPE02' }); //ctypeList
			await this.getCommCodes_({ key: 'clmDd02List', codeType: 'CLM_DD02' }); //검색날짜

			await this.searchList();
			this.$sf_toggleLoading(false);
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
